export enum SuggestionType {
  USER = 'user',
  ENTITY = 'entity',
}

export class UserSuggestionListType {
  id?: string;
  user_id: string;
  name: string | null;
  relationship_name: string | null;
  user_profile_image_url: string | null;
}

export class EntitySuggestionListType {
  id: string;
  name: string | null;
  type: string | null;
  profile_image_url: string | null;
  vault_form_id: number | null;
}

export class VaultFormType {
  id: number;
  type: string | null;
  image: string | null;
  entityData: Array<EntitySuggestionListType>;
}

export class UserTemplateSuggestionInputInterface {
  type: SuggestionType.USER | SuggestionType.ENTITY;
  userData: Array<UserSuggestionListType>;
  vaultFormTypeData: Array<VaultFormType>;
}

export class ManageSelectedSuggestionData {
  id: string | null | undefined;
}
